import React from 'react';
import styled from 'styled-components';
import { defaultMuiTheme } from '../../../../styles/MaterialTheme';
export const FEATURED_IMAGE_WIDTH = '1200px';
const MEDIA_BREAKPOINT = '750px';
const IMAGE_PADDING = '64px';
export const FeaturedImageContainer = styled.picture `
    position: absolute;
    width: calc(100% - ${IMAGE_PADDING});
    height: calc(100% - ${IMAGE_PADDING});

    ${defaultMuiTheme.breakpoints.down('md')} {
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
    }
`;
const FeaturedImage = styled.img `
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: 0.2s;
`;
const CollectionFeaturedImage = ({ desktopSrc, mobileSrc }) => {
    return (React.createElement(FeaturedImageContainer, null,
        React.createElement("source", { srcSet: `${mobileSrc}, ${desktopSrc} ${FEATURED_IMAGE_WIDTH}`, media: `(max-width: ${MEDIA_BREAKPOINT})` }),
        React.createElement(FeaturedImage, { src: desktopSrc })));
};
export default CollectionFeaturedImage;
//# sourceMappingURL=index.js.map